import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=1f1de838"
import script from "./sample.vue?vue&type=script&lang=js"
export * from "./sample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports